import { useEffect, useRef } from 'react';
import L from 'leaflet';
import { mainPhotoOf } from '../lib/model';

const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

// photo branch: every saved report / project as a photo pin on the map; tap opens its report
export const docPinsOf = (projects) => (projects || []).map((p) => {
  const reps = p.reports || [], r = reps.find((x) => x.lat != null) || p, ph = reps.map(mainPhotoOf).find(Boolean) || reps.flatMap((x) => x.photos || []).find((x) => x.kind !== 'video' && x.data);
  return ph && r.lat != null ? { id: p.id, lat: r.lat, lon: r.lon, thumb: ph.data, n: p.mode === 'single' ? 0 : reps.length, title: p.title } : null;
}).filter(Boolean);

export function useDocPins(mapRef, pins, onPick) {
  const cb = useRef(onPick); cb.current = onPick;
  const key = (pins || []).map((p) => `${p.id}|${p.lat}|${p.lon}|${p.n}|${p.thumb?.length}`).join(';');
  useEffect(() => {
    const map = mapRef.current; if (!map || !pins?.length) return undefined;
    const g = L.layerGroup(pins.map((p) => L.marker([p.lat, p.lon], {
      icon: L.divIcon({ className: 'doc-pin-wrap', html: `<div class="doc-pin" data-testid="doc-pin-${esc(p.id)}" title="${esc(p.title)}"><img src="${p.thumb}" alt=""/>${p.n ? `<b>${p.n}</b>` : ''}</div>`, iconSize: [56, 64], iconAnchor: [28, 96] }),
      zIndexOffset: 3000,
    }).on('click', () => cb.current(p.id)))).addTo(map);
    return () => g.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mapRef, key]);
}
